import React from "react";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import QRCode from "qrcode.react";
//var QRCode = require('qrcode.react');

const RenderDevice = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  showqrcode,
  handleClick,
}) => {
  const downloadQRCode = (qrValue) => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${qrValue}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  //onsole.log("tes",list)
  if (!list) return;
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" ref={lastBookElementRef} key={index}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div className="row ml-1">
                      <div className="container col-xs-12 col-sm-5">
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge badge-pill badge-secondary">
                            {item.no}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          {"Code :"} {item.name}
                        </div>

                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          {"Name :"} {item.groupname}
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"วันที่ติดตั้ง :"} {item.installdate}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Status : "}
                            {item.status === true ? (
                              <span className="badge badge-success">
                                {"ปกติ"}
                              </span>
                            ) : (
                              <span className="badge badge-danger">
                                {"ยกเลิก"}
                              </span>
                            )}

                            <span>
                              {" "}
                              {"ตรวจล่าสุด : "} {item.laststatus}{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                      

                      <div className="container col-xs-12 col-sm-5">
                      <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Location :"} {item.locationname}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Area :"} {item.areaname}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"จุดติดตั้ง :"} {item.detailname}
                          </span>
                        </div>

                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Group : "}
                            <span>{item.buname}</span>
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"รายละเอียดการติดตั้ง :"} {item.detail}
                          </span>
                        </div>
                      </div>
                      <div className="container col-xs-12 col-sm-2">
                        <div className="row">
                          <div className="d-flex justify-content-end">
                            {showqrcode && (
                              <div style={{ cursor: "pointer" }}>
                                <QRCode
                                  id={"qr-gen"}
                                  value={item.name}
                                  size={200}
                                  level={"H"}
                                  includeMargin={true}
                                />
                              </div>
                            )}

                            <div>
                              <button
                                className="btn btn-primary btn-sm m-2"
                                onClick={() =>
                                  handleOnClick(item._id, item.status,true)
                                }
                              >
                                <FontAwesome name="edit" />
                              </button>

                              {showqrcode && (
                                <button
                                  className="btn btn-secondary btn-sm m-2"
                                  onClick={() => downloadQRCode(item.name)}
                                >
                                  <FontAwesome name="download" />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={index}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div className="row ml-1">
                      <div className="container col-xs-12 col-sm-5">
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge badge-pill badge-secondary">
                            {item.no}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          {"Code :"} {item.name}
                        </div>

                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          {"Name :"} {item.groupname}
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"วันที่ติดตั้ง :"} {item.installdate}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Status : "}
                            {item.status === true ? (
                              <span className="badge badge-success">
                                {"ปกติ"}
                              </span>
                            ) : (
                              <span className="badge badge-danger">
                                {"ยกเลิก"}
                              </span>
                            )}
                            <span>
                              {" "}
                              {"ตรวจล่าสุด : "} {item.laststatus}{" "}
                            </span>
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-5">
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Location :"} {item.locationname}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Area :"} {item.areaname}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"จุดติดตั้ง :"} {item.detailname}
                          </span>
                        </div>
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"Group : "}
                            <span>{item.buname}</span>
                          </span>
                        </div>

                        
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"รายละเอียดการติดตั้ง :"} {item.detail}
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-2">
                        <div className="row">
                          <div className="d-flex justify-content-end">
                            {showqrcode && (
                              <div style={{ cursor: "pointer" }}>
                                <QRCode
                                  id={"qr-gen"}
                                  value={item.name}
                                  size={200}
                                  level={"H"}
                                  includeMargin={true}
                                />
                              </div>
                            )}

                            <div>
                              <button
                                className="btn btn-primary btn-sm m-2"
                                onClick={() =>
                                  handleOnClick(item._id, item.status,true)
                                }
                              >
                                <FontAwesome name="edit" />
                              </button>

                              {showqrcode && (
                                <button
                                  className="btn btn-secondary btn-sm m-2"
                                  onClick={() => downloadQRCode(item.name)}
                                >
                                  <FontAwesome name="download" />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RenderDevice;
